/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is this online timer free?`)
};

const es_timer_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Este temporizador online es gratis?`)
};

const de_timer_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist dieser Online-Timer kostenlos?`)
};

const nl_timer_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is deze online timer gratis?`)
};

const fr_timer_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce minuteur en ligne est-il gratuit ?`)
};

const it_timer_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo timer online è gratuito?`)
};

const pt_br2_timer_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este temporizador online é grátis?`)
};

const pt_timer_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este temporizador online é gratuito?`)
};

const ja_timer_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このオンラインタイマーは無料ですか？`)
};

const zh_timer_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个在线计时器免费吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_hub_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_hub_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_hub_faq1_q", locale)
	if (locale === "en") return en_timer_hub_faq1_q(inputs)
	if (locale === "es") return es_timer_hub_faq1_q(inputs)
	if (locale === "de") return de_timer_hub_faq1_q(inputs)
	if (locale === "nl") return nl_timer_hub_faq1_q(inputs)
	if (locale === "fr") return fr_timer_hub_faq1_q(inputs)
	if (locale === "it") return it_timer_hub_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_hub_faq1_q(inputs)
	if (locale === "pt") return pt_timer_hub_faq1_q(inputs)
	if (locale === "ja") return ja_timer_hub_faq1_q(inputs)
	return zh_timer_hub_faq1_q(inputs)
};